import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  Divider,
  Collapse,
  Button,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from "react-share";
import useStyles from "./style";
import { Button as MaterialButton } from "@material-ui/core";
// import Modal from "../../StartupDashboard/MyRequests/Modal/modal";
import Modal from "../AdminModule/Dashboard/StartupDashboard/MyRequests/Modal/modal";
import CohortTable from "./cohortTable";
import CustomTooltip from "./tooltip";
import { getMentorFeedback } from "../AdminModule/Dashboard/MentorDashboard/dependencies/action";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import {
  COHORT_PARTICULAR,
  VIEW_STARTUP_APPLICATION_DATA,
  COHORT_USER_SEND_REQUEST,
  COHORT_USER_EXIT_REQUEST,
} from "../common/constants/ApplicationUrl";
import api from "../common/dependencies/utils/Api";
import hashImage from "../../assets/images/hashImage.jpeg";
import privateCohortBtn from "../../assets/svg/shield2.svg";
import copyButton from "../../assets/svg/copyLink.svg";
import moment from "moment";
import swal from "sweetalert";
import ModalFilters from "./modalFilters";
import ModalFiltersNew from "./modalFiltersNew";
import clsx from "clsx";
import ModalFilter2 from "../common/modalFilter2";
// import shareRounded from "./img/share-round.svg";

import shareRounded  from "../AdminModule/Dashboard/MentorDashboard/MentorHome/img/share-round.svg"
const CohortParticular = () => {
  const [data, setData] = useState();
  const [toggleText, setToggleText] = useState(false);
  const [iconsCollapse, setIconsCollapse] = useState(false);
  const [datavaribale, setdatavaribale] = useState("pending");
  const [modalVisibility, setModalVisibility] = useState(false);
  const [loginData, setLoginData] = useState();
  const [isParentData, setIsParentData] = useState("");
  const [viewApplicationData, setViewApplicationData] = useState("");
  let presentTime = moment(new Date()).format("DD-MM-YYYY");
  let currentMonth = moment().format("MM");
  const [sessionDate,setSessionDate] = useState("");
  const [sessionMonth,setSessionMonth] = useState("");
  const [modalVisibility2, setModalVisibility2] = useState();
  let presentUrl =  window.location.href;
  // let sessionDate = moment(ternaryValue).format("DD-MM-YYYY");

  const LoginRole =
    localStorage.getItem("SavedLoggedInData") &&
    JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  const value =
    localStorage.getItem("SavedLoggedInData") &&
    JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const classes = useStyles();
  const history = useHistory();
  const clickedOnBack = () => {
    history.goBack();
  };
  const params = useParams();
  useEffect(() => {
    const LoginRole =
      localStorage.getItem("SavedLoggedInData") &&
      JSON.parse(localStorage.getItem("SavedLoggedInData"));
    setLoginData(LoginRole);
  }, []);

  useEffect(() => {
    loadFn()
  }, [datavaribale]);

  useEffect(() => {
    // const params = { id: props.location.state };

    loadApplication();
  }, []);
  const loadApplication =()=>{
    api
      .POST(`${VIEW_STARTUP_APPLICATION_DATA}`, { id: value?.dippNumber })
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          if (response.data.data) setViewApplicationData(response.data.data);
        } else {
        }
      })
      .catch((e) => {});
  }
  const loadFn = ()=>{
    let paramData;
    const LoginRole =
      localStorage.getItem("SavedLoggedInData") &&
      JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
    if (LoginRole === "Mentor" || LoginRole === "Admin") {
      paramData = {
        id: params.cohortId,
        mentorId: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
      };
    } else if (LoginRole === "Startup") {
      paramData = {
        id: params.cohortId,
        startupId: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
      };
    } else {
      paramData = {
        id: params.cohortId,
      };
    }
    // axios({
    //   url: COHORT_PARTICULAR,
    //   method: "post",
    //   data: paramData,
    // })
    api
      .POST(COHORT_PARTICULAR, paramData)
      .then((res) => {
        setData(res.data?.data);
        setSessionDate(moment(res?.data?.data?.cohort_date).format("DD-MM-YYYY"))
        setSessionMonth(moment(res?.data?.data?.cohort_date).format("MM"))
      })
      .catch((err) => {});
  }
  const exitCohort = () =>{
    swal("Are you sure?", "Do you want to exit this cohort?", {
      icon: "warning",
      buttons: {
        delete: {
          text: "OK",
        },
        decline: {
          text: "CANCEL",
        },
      },
    })
      .then((value) => {
        if (value === "delete") {

          exitapiCall();
        } else {
          swal("Exit cohort operation cancelled");
        }
      })

      .catch((err) => {});
  }
  const exitapiCall = () =>{
    api
    .POST(`${COHORT_USER_EXIT_REQUEST}`, { cohortId: data?.cohortId })
    .then((response) => {
      const { data, status } = response || {};
      if (status === 200) {
        swal("Success", "You exited the Cohort Successfully!", "success");
        loadApplication();
        loadFn();
      } else {
      }
    })
    .catch((e) => {});
  }
  // useEffect(() => {
  // console.log("viewApplicationData",viewApplicationData)
  // }, [viewApplicationData])
    useEffect(() => {
     if(toggleText){
      setTimeout(() => {
        setToggleText(false)
      }, 80000);
     }
    }, [toggleText])
    const handlePublicJoin = () => {
      api
        .POST(COHORT_USER_SEND_REQUEST, {
          // mentorId: value?.id,
          cohortId: data?.cohortId,
          intentToMentor: "",
          cohortType:"public",
        })
        .then((res) => {
          swal("Success", "You joined the Cohort Successfully!", "success");
          setTimeout(() => {
            loadApplication();
            loadFn();
          }, 1000);
        })
        .catch((err) => {
        });
    };
  return (
    <Box className={classes.root}>
      <ModalFilters
        cohortId={data?.cohortId}
        sendToParent={setIsParentData}
        modalVisibility={modalVisibility}
        setModalVisibility={setModalVisibility}
        fromModule="allMentorsList"
        viewApplicationData={viewApplicationData}
      />
      {/* <ModalFiltersNew
        cohortId={data?.cohortId}
        sendToParent={setIsParentData}
        modalVisibility={modalVisibility}
        setModalVisibility={setModalVisibility}
        fromModule="allMentorsList"
        viewApplicationData={viewApplicationData}
      /> */}
      <Typography
        className={clsx(classes.heading, "homepageFirstHeader", "togglediv")}
      >
      
        <div style={{display:"flex",justifyContent:"center"}}>
        {
         data != undefined && !data?.cohortVisibility &&
         <div className="newuserTooltip">
         <img className="newCohortImgBtn2" src={privateCohortBtn} />
         <span
               className="tooltiptext   tooltip-bottom"
               style={{
                 left: "8px",
                 width: "160px",
                 height: "30px",
                 top: "4rem",
               }}
             >
               Private Cohort
             </span>
             </div>        
        }
          <div>{data?.program_name}</div>
        </div>
      </Typography>
      {modalVisibility2 && (
        <ModalFilter2
          modalVisibility={modalVisibility2}
          setModalVisibility={setModalVisibility2}
          // sendToParent={setIsParentData}
          showPurposeOfMentorship={true}
          fromPage={"startUpDashboard"}
          allCalendarData={true}
          particularCohort={data?.cohortId}
        />
      )}
    
      <Typography
        className={clsx("homepageFirstHeader", "mobileHeadingxx", "togglediv2")}
      >
        {" "}
        {data?.program_name}
      </Typography>
      <Grid container style={{ marginTop: "40px" }} spacing={4}>
        <Grid
          item
          xs={12}
          md={8}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <Box
          // style={{
          //     height: "440px",
          //     width: "790px",
          //   }}
          >
            <img
              src={data?.uploadBanner || hashImage}
              className={classes.imageMain}
            />
          </Box>

          <Paper
            elevation={2}
            style={{
              marginTop: "30px",
              marginRight: "0px",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                width: "100%",
                marginTop: "1%",
              }}
            >
              <div
                className="dashboard-bottom-btn top-btn  newuserTooltip "
                onClick={() =>setModalVisibility2(true)}
                >
                <p
                  style={{ cursor: "pointer", color: "white" }}
                  className="createcohortsessionbtnpara"
                >
                  COHORTS EVENTS CALENDAR
                </p>
                <span
                  className="tooltiptext tooltip-bottom"
                  style={{ left: "150px", top: "60px", width: "250px" }}
                >
                  Click to View Cohorts Event Calendar
                </span>
              </div>
            </div>
            <Typography
              className={clsx(classes.heading5, "homepageFirstHeader")}
            >
              Program Description
            </Typography>
            {/* <Typography
              style={{ textAlign: "left" }}
              className="homepageFirstDescription"
            >
              Created By: {data?.mentor_name}
            </Typography> */}

            <Typography
              className={clsx(classes.paragraph2, "homepageFirstDescription")}
            >
              {data?.program_desc}
            </Typography>
            <Typography
              className={clsx(classes.paragraph3, "homepageFirstDescription")}
            >
              Organization Name: {data?.cohort?.organization_name}
            </Typography>
            <Typography
              className={clsx(classes.paragraph3, "homepageFirstDescription")}
            >
              Organization Type: {data?.organization_type}
            </Typography>
            <Typography
              className={clsx(classes.paragraph3, "homepageFirstDescription")}
            >
              Cohort Admin: {data?.mentor_name}
            </Typography>
            
          </Paper>
        
          <div className="shareCohortDetails">
                      <div
                        style={{
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onMouseEnter={() => setIconsCollapse(true)}
                        onMouseLeave={() => setIconsCollapse(false)}
                        className="mentorshare"
                      >
                        <img
                          src={shareRounded}
                          style={{
                            height: "40px",
                            width: "40px",
                            cursor: "pointer",
                            marginRight: "10px",
                          }}
                        />
                        <Collapse in={iconsCollapse}>
                          <Tooltip
                            classes={{
                              tooltip: classes.tooltip,
                              tooltipArrow: classes.tooltipArrow,
                            }}
                            PopperProps={{
                              disablePortal: true,
                            }}
                            arrow
                            title={
                              <Typography
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "14px",
                                  color: "#fff",
                                  fontWeight: "bold",
                                }}
                              >
                                Share on Whatsapp
                              </Typography>
                            }
                          >
                            <WhatsappShareButton
                              url={presentUrl}
                              style={{
                                height: "35px",
                                width: "35px",
                                borderRadius: "50%",
                              }}
                            >
                              <WhatsappIcon
                                style={{
                                  height: "35px",
                                  width: "35px",
                                  borderRadius: "50%",
                                }}
                              />
                            </WhatsappShareButton>
                          </Tooltip>
                          <Tooltip
                            classes={{
                              tooltip: classes.tooltip,
                              tooltipArrow: classes.tooltipArrow,
                            }}
                            PopperProps={{
                              disablePortal: true,
                            }}
                            arrow
                            title={
                              <Typography
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "14px",
                                  color: "#fff",
                                  fontWeight: "bold",
                                }}
                              >
                                Share on Facebook
                              </Typography>
                            }
                          >
                            <FacebookShareButton
                              url={presentUrl}
                              style={{
                                height: "35px",
                                width: "35px",
                                borderRadius: "50%",
                              }}
                            >
                              <FacebookIcon
                                style={{
                                  height: "35px",
                                  width: "35px",
                                  borderRadius: "50%",
                                  marginLeft:"12%"
                                }}
                              />
                            </FacebookShareButton>
                          </Tooltip>
                          {/* <Tooltip
                            classes={{
                              tooltip: classes.tooltip,
                              tooltipArrow: classes.tooltipArrow,
                            }}
                            PopperProps={{
                              disablePortal: true,
                            }}
                            arrow
                            title={
                              <Typography
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "14px",
                                  color: "#fff",
                                  fontWeight: "bold",
                                }}
                              >
                                Share on Linkedin
                              </Typography>
                            }
                          >
                            <LinkedinShareButton
                              url={presentUrl}
                              style={{
                                height: "35px",
                                width: "35px",
                                borderRadius: "50%",
                                marginLeft: "10px",
                              }}
                            >
                              <LinkedinIcon
                                style={{
                                  height: "35px",
                                  width: "35px",
                                  borderRadius: "50%",
                                }}
                              />
                            </LinkedinShareButton>
                          </Tooltip> */}
                          <Tooltip
                            classes={{
                              tooltip: classes.tooltip,
                              tooltipArrow: classes.tooltipArrow,
                            }}
                            PopperProps={{
                              disablePortal: true,
                            }}
                            arrow
                            title={
                              <Typography
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "14px",
                                  color: "#fff",
                                  fontWeight: "bold",
                                }}
                              >
                                Share on Twitter
                              </Typography>
                            }
                          >
                            <TwitterShareButton
                              url={presentUrl}
                              style={{
                                height: "35px",
                                width: "35px",
                                borderRadius: "50%",
                                marginLeft: "10px",
                              }}
                            >
                              <TwitterIcon
                        style={{
                          height: "35px",
                          width: "35px",
                          borderRadius: "50%",
                        }}
                      />
                            </TwitterShareButton>
                          </Tooltip>
                          <Tooltip
                            classes={{
                              tooltip: classes.tooltip,
                              tooltipArrow: classes.tooltipArrow,
                            }}
                            PopperProps={{
                              disablePortal: true,
                            }}
                            arrow
                            title={
                              <Typography
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "14px",
                                  color: "#fff",
                                  fontWeight: "bold",
                                }}
                              >
                              {toggleText ? "URL copied to clipboard" : "Copy to clipboard"}  
                              </Typography>
                            }
                          >
                                                           <TwitterShareButton 
                                                        onClick={() => {setToggleText(!toggleText); navigator.clipboard.writeText(presentUrl)}}
                                                        >
                            <div 
                             style={{
                              height: "21px",
                              width: "30px",
                              borderRadius: "50%",
                              marginLeft: "10px",
                            }}
                            onClick={() => {setToggleText(!toggleText); navigator.clipboard.writeText(presentUrl)}}

                            >
                            <img src={copyButton}
                            onClick={() => {setToggleText(!toggleText); navigator.clipboard.writeText(presentUrl)}}

                            //  style={{position:"relative",top:"10px"}}
                              />
                              </div>
                              </TwitterShareButton>
                          </Tooltip>
                        </Collapse>
                      </div>
                    </div>
                  
          {/* <CohortTable data={data} /> */}
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper
            elevation={2}
            style={{
              borderRadius: "10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "20px",
            }}
          >
            <img
              src={data?.uploadLogo || hashImage}
              style={{
                height: "170px",
                width: "170px",
                objectFit: "contain",
                maxHeight: "none",
                maxWidth: "none",
                borderRadius: "10px",
                marign: "auto",
              }}
              className={classes.image}
            />
            <Typography
              className={clsx(classes.heading3, "homepageFirstDescription")}
            >
              Cohort Start Date
            </Typography>
            <Box className={clsx(classes.box1, "homepageFirstDescription")}>
              {data?.cohort_date
                ? moment(data?.cohort_date).format("Do MMMM YYYY")
                : ""}
            </Box>
            <Typography
              className={clsx(classes.heading3, "homepageFirstDescription")}
            >
              Cohort Duration
            </Typography>
            <Box className={clsx(classes.box1, "homepageFirstDescription")}>
              {
                data?.infiniteDuration ? "Unlimited duration" : `${data?.program_duration} Months`
              }
            </Box>
          </Paper>
          {loginData?.role === "Startup" &&
            loginData?.applicationStatus === "SUBMITTED" &&
            data?.cohort?.cohortStatus !== "CLOSED" && (
              <Paper
                elevation={2}
                style={{
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "20px",
                  marginTop: "30px",
                }}
              >
                <Typography
                  className={clsx(classes.heading5, "homepageFirstDescription")}
                >
                  FOR STARTUPS
                </Typography>
                {
               ( data?.startup_start_date !== null && data?.startup_start_date !== "" && data?.startup_start_date !== undefined ) &&
               <>
              <Typography
                  className={clsx(classes.heading3, "homepageFirstDescription")}
                >
                  Application Start Date
                </Typography>
                <Box className={clsx(classes.box2, "homepageFirstDescription")}>
                  {data?.startup_start_date
                    ? moment(data?.startup_start_date).format("Do MMMM YYYY")
                    : ""}
                </Box>
                </>
                }
                
              
               {
               ( data?.startup_end_date !== null && data?.startup_end_date !== "" && data?.startup_end_date !== undefined ) &&
               <>
               <Typography
               className={clsx(classes.heading3, "homepageFirstDescription")}
             >
               Application End Date
             </Typography>
                 <Box className={clsx(classes.box2, "homepageFirstDescription")}>
                  {data?.startup_end_date
                    ? moment(data?.startup_end_date).format("Do MMMM YYYY")
                    : ""}
                </Box>
                </>}
                {data?.applied === false ? (

                  data?.cohortVisibility ? 
                  <>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "#644b9f",
                          color: "white",
                          fontFamily: "Montserrat",
                          padding: "0px 30px",
                          borderRadius: "20px",
                          marginTop: "20px",
                        }}
                        onClick={()=>{handlePublicJoin()}}
                      >
                        JOIN NOW
                      </Button>
                  </>
                  :

                  <CustomTooltip
                    fromModule="CohortParticular"
                    isPurpose={false}
                    cohortData={data}
                    isRequestSent={datavaribale}
                    change={setdatavaribale}
                  >
                    <div className="newuserTooltip top-btn">
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "#644b9f",
                          color: "white",
                          fontFamily: "Montserrat",
                          padding: "0px 30px",
                          borderRadius: "20px",
                          marginTop: "20px",
                        }}
                      >
                        APPLY NOW
                      </Button>
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "52px", width: "130px" }}
                      >
                        Click to Apply
                      </span>
                    </div>
                  </CustomTooltip>
                ) : (
                  data?.requestStatus == "Accepted" ?
                  <div className="newuserTooltip top-btn">
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#644b9f",
                      color: "white",
                      fontFamily: "Montserrat",
                      padding: "0px 30px",
                      borderRadius: "20px",
                      marginTop: "20px",
                    }}
                    disableRipple
                    disableFocusRipple
                    disableTouchRipple
                    onClick={()=>{
                      exitCohort();
                    }}
                  >
                    Exit Cohort
                  </Button>
                  <span
                    className="tooltiptext tooltip-bottom"
                    style={{ left: "43px", top: "52px", width: "190px" }}
                  >
                    Click to exit cohort
                  </span>
                </div>
                  :
                  
                  <div className="newuserTooltip top-btn">
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#644b9f",
                        color: "white",
                        fontFamily: "Montserrat",
                        padding: "0px 30px",
                        borderRadius: "20px",
                        marginTop: "20px",
                      }}
                      disableRipple
                      disableFocusRipple
                      disableTouchRipple
                    >
                      Applied
                    </Button>
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ left: "43px", top: "52px", width: "190px" }}
                    >
                      You Have Already Applied
                    </span>
                  </div>
                )}
                {/* <div className="newuserTooltip top-btn">
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#644b9f",
                      color: "white",
                      fontFamily: "Montserrat",
                      padding: "0px 30px",
                      borderRadius: "20px",
                      marginTop: "20px",
                    }}
                    onClick={() =>
                      data?.applied === false ? setModalVisibility(true) : ""
                    }
                  >
                    {data?.applied === false ? "JOIN" : "Applied"}
                  </Button>
                  <span
                    className="tooltiptext tooltip-bottom"
                    style={{ left: "43px", top: "52px", width: "190px" }}
                  >
                    {data?.applied === false
                      ? " Click to Join Cohort"
                      : "You Have Already Applied"}
                  </span>
                </div> */}
              </Paper>
            )}
 {
   ( ( currentMonth > sessionMonth) || (currentMonth == sessionMonth && presentTime > sessionDate) ) &&
  <Paper
            elevation={2}
            style={{
              borderRadius: "10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "20px",
              marginTop: "30px",
            }}
          >
            <Typography
              className={clsx(classes.heading5, "homepageFirstDescription")}
            >
              COHORT MEMBERS
            </Typography>
            {/* <Typography
                  className={clsx(classes.heading3, "homepageFirstDescription")}
                > */}
            <div className="cohortNewBox">
              <div>Total Members:</div>
              <div>
                {Number(data?.numberofmentors) + Number(data?.numberofstartups)}
              </div>
            </div>
            {/* </Typography> */}

            {/* <Typography
                  className={clsx(classes.heading3, "homepageFirstDescription")}
                > */}
            <div className="cohortNewBox">
              <div>Startups:</div>
              <div>{data?.numberofstartups}</div>
            </div>
            {/* </Typography> */}
            {/* <Typography
                  className={clsx(classes.heading3, "homepageFirstDescription")}
                > */}
            <div className="cohortNewBox">
              <div>Mentors:</div>
              <div>{data?.numberofmentors}</div>
            </div>
            {/* </Typography> */}
          </Paper>
 }
          
          {LoginRole === "Mentor" &&
            value?.applicationStatus === "VERIFIED" &&
            data?.cohort?.cohortStatus !== "CLOSED" &&
            (value?.id !== data?.mentorId ? (
              <Paper
                elevation={2}
                style={{
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "20px",
                  marginTop: "30px",
                }}
              >
                <Typography
                  className={clsx(classes.heading2, "homepageFirstDescription")}
                >
                  FOR MENTORS
                </Typography>
                <Box className={clsx(classes.box3, "homepageFirstDescription")}>
                  Interested to become a Mentor on this COHORT program?
                </Box>
                {data?.applied === false ? (
                    data?.cohortVisibility ? 
                    <>
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: "#644b9f",
                            color: "white",
                            fontFamily: "Montserrat",
                            padding: "0px 30px",
                            borderRadius: "20px",
                            marginTop: "20px",
                          }}
                          onClick={()=>{handlePublicJoin()}}
                        >
                          JOIN NOW
                        </Button>
                    </>
                    :
                  <CustomTooltip
                    fromModule="CohortParticular"
                    isPurpose={false}
                    cohortData={data}
                    isRequestSent={datavaribale}
                    change={setdatavaribale}
                  >
                    <div className="newuserTooltip top-btn">
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "#644b9f",
                          color: "white",
                          fontFamily: "Montserrat",
                          padding: "0px 30px",
                          borderRadius: "20px",
                          marginTop: "20px",
                        }}
                      >
                        APPLY NOW
                      </Button>
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "52px", width: "130px" }}
                      >
                        Click to Apply
                      </span>
                    </div>
                  </CustomTooltip>
                ) : (
                  data?.requestStatus == "Accepted" ?
                  <div className="newuserTooltip top-btn">
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#644b9f",
                      color: "white",
                      fontFamily: "Montserrat",
                      padding: "0px 30px",
                      borderRadius: "20px",
                      marginTop: "20px",
                    }}
                    disableRipple
                    disableFocusRipple
                    disableTouchRipple
                    onClick={()=>{
                      exitCohort();
                    }}
                  >
                    Exit Cohort
                  </Button>
                  <span
                    className="tooltiptext tooltip-bottom"
                    style={{ left: "43px", top: "52px", width: "190px" }}
                  >
                    Click to exit cohort
                  </span>
                </div>
                  :
                  <div className="newuserTooltip top-btn">
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#644b9f",
                        color: "white",
                        fontFamily: "Montserrat",
                        padding: "0px 30px",
                        borderRadius: "20px",
                        marginTop: "20px",
                      }}
                      disableRipple
                      disableFocusRipple
                      disableTouchRipple
                    >
                      Applied
                    </Button>
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ left: "43px", top: "52px", width: "190px" }}
                    >
                      You Have Already Applied
                    </span>
                  </div>
                )}
              </Paper>
            ) : (
              ""
            ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default CohortParticular;
